<template>
  <div>
    <ul v-if="!editTags" @click="tagOpen()">
      <li v-show="value.length == 0" class="multiselect story-tags">
        <span class="multiselect__placeholder">Tags</span>
      </li>
      <li v-for="tag in value" v-bind:key="tag.id">
        <span class="badge">{{ tag.text }}</span>
      </li>
    </ul>
    <multiselect
      ref="multiselect"
      v-if="editTags"
      :options="tags"
      track-by="id"
      label="text"
      :value="value"
      :multiple="true"
      :searchable="true"
      :close-on-select="true"
      :clear-on-select="false"
      :show-labels="false"
      placeholder="Add tags..."
      @input="handleSelectTagCallback"
      :taggable="true"
      :hideSelected="true"
      name="tags"
      class="story-tags"
      :tag-placeholder="`Create new tag...`"
      @tag="handleAddNewTag"
      @close="tagClosed"
    ></multiselect>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { filter, cloneDeep, debounce } from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  props: {
    value: {
      type: null,
      default() {
        return []
      },
    },
  },

  components: {
    Multiselect,
  },

  data: function () {
    return {
      editTags: false,
    }
  },

  computed: {
    ...mapState('yodizproject/tags', { tags: 'list' }),
  },

  methods: {
    ...mapActions('yodizproject/tags', {
      addTag: 'addListObject',
      getTags: 'getList',
    }),
    tagOpen() {
      this.editTags = true
      this.$nextTick(() => {
        this.$refs.multiselect.$el.focus()
      })
    },
    tagClosed(value, id) {
      this.editTags = false
    },
    handleSelectTagCallback(tags) {
      this.$emit('input', tags)
    },

    handleAddNewTag(text) {
      return this.addTag({ payload: { text: text, area: 'scrumboard' } }).then((response) => {
        this.$emit('tag', response.data)
      })
    },

    searchTags: debounce(async function (search) {
      console.log('here')
      await this.getTags({ text: search, area: 'scrumboard' })
    }, 1250),
  },
}
</script>

<style scoped>
  ul {
    list-style: none; 
    padding-inline-start: 0px;
    margin-bottom:0px;
  }

  ul li {
    display: inline; 
    padding-right: 5px
  }


</style>